import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { TranslateConfigService } from './translate-config.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    private platform: Platform,
    private translate: TranslateConfigService
    ) { }

  // Tracks a custom event in Firebase Analytics
  logEvent(name: string, properties: object) {
    this.platform.ready().then(() => {
      // EX: analytics.logEvent({ name: 'purchase', params: { items: '[1, 2, 3]', total: 254.5 } });
      FirebaseAnalytics.logEvent({name, params: properties});
    });
  }

  setUserProperty(key: string, value: string) {
    this.platform.ready().then(() => {
      FirebaseAnalytics.setUserProperty({
        name: key,
        value,
      });
    });
  }

  // Tracks an 'screen_view' event in Firebase Analytics
  trackScreen(name: string) {
    this.platform.ready().then(() => {
      FirebaseAnalytics.setScreenName({
        screenName: name,
        nameOverride: name,
      });
    });
  }

  setUserId(uid: string) {
    this.platform.ready().then(() => {
      FirebaseAnalytics.setUserId({ userId: uid });
    });
  }

  async setAnalyticsUserProperties(clientType: string, clientCategory: string, tariffCategory: string, tariffName: string, userId: string){
    this.setUserProperty("clientType", clientType);
    this.setUserProperty("clientCategory", clientCategory);
    this.setUserProperty("tariffCategory", tariffCategory);
    this.setUserProperty("tariffName", tariffName);
    this.setUserId(userId);
    this.setUserProperty("langApp", this.translate.languageDefault);
  }
}
